// The backend this build talks to.
//
// Create React App resolves process.env.REACT_APP_* at BUILD time — the value
// is baked into the bundle the browser downloads, so it cannot be changed on
// the server afterwards. The deploy workflow supplies it per environment from
// a GitHub Actions repository variable (STAGING_SERVER_URL / PROD_SERVER_URL),
// which is what lets the staging and production branches hold identical source
// instead of differing by a hardcoded URL.
//
// Local development reads it from .env.development. A production build without
// it fails in the prebuild guard (scripts/require-env.js) rather than shipping
// a bundle pointed at nothing.
const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default SERVER_URL;
